<section class="mtb">
  <div class="trip-detail-popup-right">
    <div class="header">
      <div class="row">
        <div class="col-sm-9">
          <h5>Driver Route Details</h5>
        </div>
        <div class="image-fluid col-sm-3">
          <img
            (click)="close()"
            src="../../../assets/img/icons8-macos-close-60.png"
            class="close-icons"
          />
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
  </div>
  <div class="view-details">
    <div class="route-details">
      <div class="row mtb">
        <div class="col-md-6 d-flex justify-content-between">
          <div class="fare">
            {{ driverData.driver_route_unique_id }}
            <span style="font-size: 13px; font-weight: normal; color: gray;" *ngIf="driverData.createdAt">
              ( {{ driverData.createdAt | date : "dd-MM-yyyy, hh:mm a" }} )
            </span>
          </div>
          <div class="fare">{{ driverData.trip_details?.[0]?.trip_id }}</div>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-md-6 d-flex justify-content-between">
          <div class="cost">
            Driver Name : {{ driverData.driver_details?.[0]?.username || 'N/A' }}
          </div>
          <div class="cost">
            Driver Contact : {{ driverData.driver_details?.[0]?.mobile || 'N/A' }}
          </div>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-md-6 d-flex justify-content-between">
          <div class="cost">
            Truck No : {{ driverData.truck_details?.[0]?.truck_number }}
          </div>
          <div class="cost">
            Vehicle Type :
            {{ driverData.vehicle_type?.[0]?.vehicle_type_name || (driverData.truck_category?.[0]?.truck_category_name + ' - ' + driverData.truck_type?.[0]?.truck_weight) || 'N/A' }}
          </div>
        </div>
      </div>
      <div class="row mtb" *ngIf="driverData.trip_details?.[0]?.userInfo?.user_type == 'corporate'">
        <div class="col-md-6 d-flex justify-content-between">
          <div class="cost">
            Corporate Name :
            {{ driverData.trip_details?.[0]?.userInfo?.company_name }}
          </div>
          <div class="cost">
            Corporate Contact :
            {{ driverData.trip_details?.[0]?.userInfo?.mobile }}
          </div>
        </div>
      </div>
      <div class="row mtb" *ngIf="driverData.trip_details?.[0]?.userInfo?.user_type == 'customer'">
        <div class="col-md-6 d-flex justify-content-between">
          <div class="cost">
            Customer Name :
            {{ driverData.trip_details?.[0]?.userInfo?.username }}
          </div>
          <div class="cost">
            Customer Contact :
            {{ driverData.trip_details?.[0]?.userInfo?.mobile }}
          </div>
        </div>
      </div>
    </div>

    <div class="fare-calc">
      <div class="row mtb">
        <div class="col-md-6 fare-details">
          <div class="fare">Actual Amount</div>
          <div *ngIf="driverData?.trip_details?.[0]?.userInfo?.user_type !== 'corporate'">
            ₹ {{ driverData?.route_fare | number: '1.2-2' }} /-
          </div>
          <div *ngIf="driverData?.trip_details?.[0]?.userInfo?.user_type === 'corporate'">
            ₹
            {{
              driverData?.bidDetails?.[0]?.trip_status === 'pending' ||
              driverData?.bidDetails?.[0]?.trip_status === 'trip_not_booked'
                ? (0 | number: '1.2-2')
                : (
                    driverData?.workorderInfo?.[0]?.pay_as_load_quantity === 'loaded_quantity'
                      ? (driverData?.tripInfo?.workOrderOtherDetails?.price_per_ton || 0) *
                        (driverData?.tripInfo?.workOrderOtherDetails?.loading_point || 0)
                      : driverData?.workorderInfo?.[0]?.pay_as_load_quantity === 'unloaded_quantity'
                      ? (driverData?.tripInfo?.workOrderOtherDetails?.price_per_ton || 0) *
                        (driverData?.tripInfo?.workOrderOtherDetails?.unloading_point || driverData?.tripInfo?.workOrderOtherDetails?.loading_point || 0)
                      : driverData?.trip_payment_info?.[0]?.price_details?.amount_paid ||
                        driverData?.price || 0
                  ) | number: '1.2-2'
            }}
            /-
          </div>
        </div>
      </div>
      <div class="row mtb" *ngIf="driverTax && driverTax.length > 0">
        <div class="col-md-6">
          <div class="deduct">Deductions</div>
        </div>
      </div>
      <div *ngFor="let item of driverTax">
        <div class="row mtb">
          <div class="col-md-6 d-flex justify-content-between">
            <div class="cost">
              {{ item?.tax_name }} :
              <span *ngIf="item?.tax_type == 'percentage' || item?.tax_type == 'percent'">
                ({{ item?.tax_deduction }} %)
              </span>
            </div>
            <div
              class="card-details-right trip_details"
              *ngIf="item?.tax_type == 'percentage' || item?.tax_type == 'percent'"
            >
              ₹
              {{
                ((driverData?.trip_payment_info?.[0]?.price_details
                  ?.actual_price ||
                  driverData?.price ||
                  0) *
                  item.tax_deduction) /
                  100 | number : "1.2-2"
              }}
            </div>
            <div
              class="card-details-right trip_details"
              *ngIf="item?.tax_type == 'amount'"
            >
              ₹ {{ item.tax_deduction }} /-
            </div>
          </div>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-md-6 border"></div>
      </div>
      <div class="row mtb">
        <div class="col-md-6 fare-details">
          <div class="fare">Total Fare</div>
          <!-- For Normal Customers or Unbooked -->
          <div *ngIf="driverData?.trip_details?.[0]?.userInfo?.user_type !== 'corporate'">
            ₹ {{ driverData?.total_fare | number: '1.2-2' }} /-
          </div>

          <!-- For Corporate Users -->
          <div *ngIf="driverData?.trip_details?.[0]?.userInfo?.user_type === 'corporate'">
            ₹
            {{
              driverData?.bidDetails?.[0]?.trip_status === 'pending' ||
              driverData?.bidDetails?.[0]?.trip_status === 'trip_not_booked'
                ? (0 | number: '1.2-2')
                : (
                    driverData?.workorderInfo?.[0]?.pay_as_load_quantity === 'loaded_quantity'
                      ? (driverData?.tripInfo?.workOrderOtherDetails?.price_per_ton || 0) *
                        (driverData?.tripInfo?.workOrderOtherDetails?.loading_point || 0)
                      : driverData?.workorderInfo?.[0]?.pay_as_load_quantity === 'unloaded_quantity'
                      ? (driverData?.tripInfo?.workOrderOtherDetails?.price_per_ton || 0) *
                        (driverData?.tripInfo?.workOrderOtherDetails?.unloading_point || driverData?.tripInfo?.workOrderOtherDetails?.loading_point || 0)
                      : driverData?.trip_payment_info?.[0]?.price_details?.amount_paid ||
                        driverData?.total_fare || 0
                  ) | number: '1.2-2'
            }}
            /-
          </div>
        </div>
      </div>
      <div class="row mtb">
        <div class="col-md-6">
          <div class="deduct" *ngIf="driverData?.trip_details?.[0]?.userInfo?.user_type === 'customer'">
            (Route Fare After Deductions)
          </div>
          <div class="deduct" *ngIf="driverData?.trip_details?.[0]?.userInfo?.user_type === 'corporate'">
            (Route Fare as Loaded/Unloaded Quantity)
          </div>
        </div>
      </div>
    </div>

    <div class="trip-details">
      <div class="row mtb">
        <div class="col-md-6 fare">Trip Details</div>
      </div>
      <div class="row mtb">
        <div class="col-md-6 d-flex justify-content-between">
          <div class="cost">
            Truck Category :
            {{ data?.truck_category?.[0]?.truck_category_name }}
          </div>
          <div class="cost">
            Weight : {{ data?.truck_type?.[0]?.truck_weight }}
          </div>
        </div>
      </div>
      <div class="row mtb" *ngIf="data?.trip_details?.[0]?.load_type != null">
        <div class="col-md-6">
          <div class="cost">
            Load Type : {{ data?.trip_details?.[0]?.load_type }} /
            {{ data?.trip_details?.[0]?.material_type }}
          </div>
        </div>
      </div>
    </div>

    <div class="locations">
      <div class="row mtb">
        <div class="col-md-6 fare">Pickup and Dropoff Locations :-</div>
      </div>
      <div class="payment-container">
        <div class="location-payment">
          <div class="places">
            <div class="place-row">
              <mat-icon>near_me</mat-icon>
              <div class="place-text">
                <h4>{{ data?.fromLocation?.from_city_name }}</h4>
                {{ data?.tripInfo?.from_complete_address }}
                <div class="result">Contact: {{ data?.trip_details?.[0]?.pickup_name }} - {{ data?.trip_details?.[0]?.pickup_contact }}</div>
              </div>
            </div>
            <div class="place-row"
                *ngFor="let stop of data?.stops; let i = index">
              <mat-icon>stop_circle</mat-icon>
              <div class="place-text">
                <h4>Stop {{ i + 1 }}: {{ stop.city_name }}</h4>
                {{ stop.complete_address }}
                <div class="result">Contact: {{ stop?.stop_contact_name }} - {{ stop?.stop_contact_number }}</div>
              </div>
            </div>
            <div class="place-row">
              <mat-icon>location_on</mat-icon>
              <div class="place-text">
                <h4>{{ data?.toLocation?.to_city_name }}</h4>
                <div>{{ data?.tripInfo?.to_complete_address }}</div>
                <div class="result">Contact: {{ data?.trip_details?.[0]?.dropoff_name }} - {{ data?.trip_details?.[0]?.dropoff_contact }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="fare" *ngIf="transporter_details && transporter_details.length > 0">
      <h5>Payments Details</h5>
      <mat-divider></mat-divider>
      <form *ngFor="let item of transporter_details; let i = index">
        <div>
          <div class="fare mt-2">{{ getPaymentLabel(i + 1) }} Payment</div>
          <div class="row mt-3 ml-0 mr-0 d-flex">
            <div class="col-md-6">
              <div class="cost">Transaction ID:</div>
              <h6>
                {{ item.transaction_id || "N/A" }}
              </h6>
            </div>
            <div class="col-md-6">
              <div class="cost">Amount:</div>
              <h6>{{ item.transaction_amount }}</h6>
            </div>
          </div>
          <div class="row mt-3 ml-0 mr-0 d-flex">
            <div class="col-md-6">
              <div class="cost">Pay Mode:</div>
              <h6>{{ item.payment_type | uppercase }}</h6>
            </div>
            <div class="col-md-6">
              <div class="cost">Pay Date:</div>
              <h6>
                {{ item.payment_date | date : "dd-MM-yyyy" }}
              </h6>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="fare" *ngIf="driver_Trip_Details && driver_Trip_Details.length > 0">
      <div class="heading">
        <h5>Trip History</h5>
        <mat-divider></mat-divider>
      </div>
      <div class="history" *ngFor="let item of driver_Trip_Details">
        <div class="row mt-3 ml-0 mr-0 d-flex">
          <div class="col-md-6">
            <div class="cost">Date:</div>
            <h6>
              {{ item?.date | date : "dd-MM-yyyy" }}
            </h6>
          </div>
          <div class="col-md-6">
            <div class="cost">Time:</div>
            <h6>
              {{ item?.time }}
            </h6>
          </div>
        </div>
        <div class="row mt-3 ml-0 mr-0 d-flex">
          <div class="col-md-6">
            <div class="cost">Status:</div>
            <h6>{{ item.status }}</h6>
          </div>
          <div class="col-md-6">
            <div class="cost">Location:</div>
            <h6>
              {{ item.location }}
            </h6>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-md-12">
        <button
          *ngIf="driverData?.driver_trip_route_status == 'new_route'"
          type="button"
          class="btn button buttonDelete pull-right me-3"
          (click)="cancelDRO(driverData._id)"
        >
          Cancel DRO
        </button>
      </div>
    </div>
  </div>
</section>
